import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Button, Card, Descriptions } from 'antd';
import { postApi } from 'apis';
import { toastText } from 'utils/utils';

const ValidateAdminPassForm = ({ deviceId, setOpenClientMode }: any) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [responseData, setResponseData] = useState<any>(null);
	const [adminPasswordUsed, setAdminPasswordUsed] = useState<string | null>(
		null,
	);
	console.log(adminPasswordUsed);
	const cardRef = useRef<HTMLDivElement>(null);

	const onFinish = async (values: any) => {
		setLoading(true);
		try {
			const res = await postApi('/devices/validate-admin-pass', {
				deviceId,
				...values,
			});

			if (res?.data?.data) {
				toastText(res?.data?.message, 'success');
				setResponseData(res.data.data);
				setAdminPasswordUsed(values.adminPassword);
			}
		} catch (err: any) {
			toastText(err?.response?.data?.message, 'error');
		} finally {
			setLoading(false);
			form.resetFields();
		}
	};

	const handleClose = () => {
		setResponseData(null);
		setAdminPasswordUsed(null);
		form.resetFields();
		setOpenClientMode(false);
	};

	// Detect click outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				cardRef.current &&
				!cardRef.current.contains(event.target as Node)
			) {
				handleClose();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div ref={cardRef}>
			<Card
				title={
					responseData ? 'Client Mode Info' : 'Enter Admin Password'
				}
			>
				{!responseData ? (
					<Form
						form={form}
						layout="vertical"
						onFinish={onFinish}
						autoComplete="off"
					>
						<Form.Item
							label="Admin Password"
							name="adminPassword"
							rules={[
								{
									required: true,
									message: 'Please enter admin password',
								},
							]}
						>
							<Input.Password placeholder="Enter admin password" />
						</Form.Item>

						<Form.Item>
							<Button
								type="primary"
								htmlType="submit"
								loading={loading}
								style={{ marginTop: 12 }}
							>
								Submit
							</Button>
						</Form.Item>
					</Form>
				) : (
					<>
						<Descriptions bordered column={1} size="middle">
							<Descriptions.Item label="Hotspot ID">
								{responseData?.hotspotId || '-'}
							</Descriptions.Item>
							<Descriptions.Item label="Hotspot Password">
								{responseData?.hotspotPassword || '-'}
							</Descriptions.Item>
							<Descriptions.Item label="Client ID">
								{responseData?.clientId || '-'}
							</Descriptions.Item>
							<Descriptions.Item label="Client Password">
								{responseData?.clientPassword || '-'}
							</Descriptions.Item>
							<Descriptions.Item label="Admin ID">
								{responseData?.adminId || '-'}
							</Descriptions.Item>
							<Descriptions.Item label="Admin Password">
								{responseData?.adminPassword || '-'}
							</Descriptions.Item>
						</Descriptions>

						<Button
							type="primary"
							onClick={handleClose}
							style={{ marginTop: 20 }}
						>
							Close
						</Button>
					</>
				)}
			</Card>
		</div>
	);
};

export default ValidateAdminPassForm;
